var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface2077939"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(15.686275%,37.64706%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 15 2 C 7.832031 2 2 7.832031 2 15 C 2 22.167969 7.832031 28 15 28 C 22.167969 28 28 22.167969 28 15 C 28 7.832031 22.167969 2 15 2 Z M 15 4 C 21.085938 4 26 8.914062 26 15 C 26 20.53125 21.933594 25.082031 16.625 25.867188 L 16.625 18.179688 L 19.730469 18.179688 L 20.21875 15.027344 L 16.625 15.027344 L 16.625 13.300781 C 16.625 11.992188 17.050781 10.828125 18.277344 10.828125 L 20.246094 10.828125 L 20.246094 8.074219 C 19.898438 8.027344 19.167969 7.925781 17.785156 7.925781 C 14.898438 7.925781 13.203125 9.453125 13.203125 12.925781 L 13.203125 15.023438 L 10.234375 15.023438 L 10.234375 18.179688 L 13.207031 18.179688 L 13.207031 25.839844 C 7.980469 24.984375 4 20.472656 4 15 C 4 8.914062 8.914062 4 15 4 Z M 15 4 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b3b21e29200359aa0221d103e2ce163b.svg";
export { ForwardRef as ReactComponent };